/** Canvas colours come from the CSS theme tokens (src/ui/tokens.css), re-read when the theme changes. */
const KEYS = ["sea", "land", "land-edge", "lake", "river", "state", "border-line", "grat", "grat-text", "city", "city-dot", "ink", "ink-2", "ink-3", "halo", "panel", "accent", "guess", "good", "bad", "ghost", "l0", "l1", "l2", "l3", "l4", "l5", "route-pin", "route-next", "route-who"] as const;
export type ColorKey = (typeof KEYS)[number];
export type Colors = Record<ColorKey, string> & { fmono: string; fsans: string };

export function readColors(): Colors {
  const cs = getComputedStyle(document.documentElement);
  const c = { fmono: cs.getPropertyValue("--mono").trim(), fsans: cs.getPropertyValue("--sans").trim() } as Colors;
  for (const k of KEYS) c[k] = cs.getPropertyValue(`--${k}`).trim();
  return c;
}

export function onThemeChange(fn: () => void): void {
  matchMedia("(prefers-color-scheme: dark)").addEventListener("change", fn);
  new MutationObserver(fn).observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
}
